import Box from '@mui/material/Box';
import LoadingIcon from '../../icons/LoadingIcon';
import { keyframes } from '@mui/system';
import PageTitle from './PageTitle';

const float = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
`;

export default function Loading({ height, title }: { height?: string, title?: string }) {
  const containerHeight = height || '80vh';
  return (
    <Box display="flex" justifyContent="center" height={containerHeight} >
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        <Box
          sx={{
            width: 140,
            animation: `${float} 2s ease-in-out infinite`
          }}
        >
          <LoadingIcon />
        </Box>
        <PageTitle
          title={title ?? 'loading, please wait...'}
          sx={{
            textTransform: 'none',
            mt: 1,
            fontWeight: 'medium',
            fontSize: '18px',
            animation: `${float} 2s ease-in-out infinite`,
            animationDelay: '0.5s'
          }}
          appColors
        ></PageTitle>
      </Box>
    </Box>
  );
}
